import type { SVGProps } from 'react';
const SvgDiamondPlaceholder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M8.803 1.377a1.038 1.038 0 0 0-1.6 0L2.255 7.295a1.1 1.1 0 0 0 0 1.41L7.2 14.624a1.037 1.037 0 0 0 1.6 0l4.945-5.917a1.1 1.1 0 0 0 0-1.411z"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgDiamondPlaceholder;
